import {Component} from '@angular/core';
import {DxDataGridComponent, DxFormComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoLookupComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {FilterPanelComponent} from "../../../../components/library/filter-panel/filter-panel.component";
import {MB51GridViewDto, MB51Reason, MB51Status} from "@services";
import {FilterConfig, GridPageComponent} from "../../../common/grid-page.component";
import EnumUtils from "../../../../shared/enum-utils";
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {NgClass} from "@angular/common";

@Component({
    selector: 'app-mb51-data',
    imports: [
        DxDataGridComponent,
        DxFormComponent,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoLookupComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoPositionComponent,
        DxoScrollingComponent,
        DxoSearchComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        FilterPanelComponent,
        CapitalCasePipe,
        DxTemplateDirective,
        NgClass
    ],
    templateUrl: './mb51-data.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 150px);
        }`
    ]
})
export class MB51DataComponent extends GridPageComponent<MB51GridViewDto> {

    constructor() {
        super();
        this.init(MB51GridViewDto);
    }

    readonly numberFormat = "#,##0";
    readonly decimalFormat = "#,##0.##";
    readonly statusOptions = EnumUtils.getEnumOptions(MB51Status);
    readonly reasonOptions = EnumUtils.getEnumOptions(MB51Reason);

    dataSource = this.dataSources.mb51();

    protected override exportName: string = "MB51";
    protected override enableDeepLinkDateFilter = true;

    protected override filterConfig: FilterConfig[] = [
        {field: 'created', op: '>='},
        {field: 'material', op: 'contains'},
        {field: 'matDoc', op: 'contains'},
        {field: 'item', op: 'contains'},
        {field: 'batch', op: 'contains'},
        {field: 'materialDescription', op: 'contains'},
        {field: 'documentHeaderText', op: 'contains'},
        {field: 'reference', op: 'contains'},
        {field: 'reason', op: '='},
        {field: 's', op: 'contains'},
        {field: 'postingDate', op: '>='},
        {field: 'quantity', op: '>='},
        {field: 'amountInLc', op: '>='},
        {field: 'status', op: '='},
        {field: 'duplicate', op: '='},
        {field: 'dateCompleted', op: '>='},
        {field: 'lastSeenInUpload', op: '>='},
    ];

    protected getStatusBadgeClass(status: MB51Status) : string{
        switch (status) {
            case "Active":
                return 'bg-success-subtle text-success';
            case "Completed":
                return 'bg-secondary-subtle text-secondary';
        }
    }

    protected getReasonBadgeClass(status: MB51Reason) : string{
        switch (status) {
            case "Damage":
                return 'bg-danger-subtle text-danger';
            case "Adjustment":
                return 'bg-info-subtle text-info';
        }
    }
}
